import Vue from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css'; // 引入antd样式
import router from './router'; // 引入router配置
Vue.config.productionTip = false
Vue.use(Antd);
new Vue({
  render: h => h(App),
  router//使用router
}).$mount('#app')
